<template>
<nav class="navbar fixed-top navbar-expand-lg navbar-light bg-white shadow-reg" style="padding: .3rem 1rem;">
    <div class="container">
        <router-link to="/" v-slot="{ href, navigate }">
            <a class="navbar-brand" :href="href" @click="navigate">
                <img id="navbar-brand-image" :src="headerImage" class="__red_logo" alt="main-logo-red" height="50px"> 
            </a>
        </router-link>
        <!-- <form class="form-inline" style="flex-grow: 3;">
            <input class="form-control" type="search" placeholder="Search shops" aria-label="Search" style="width: 100%;">
        </form> -->
        <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#header-navbar" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button> -->
        <div class="navbar" id="header-navbar">
        <!-- <div class="collapse navbar navbar-collapse" id="header-navbar"> -->
            <ul class="navbar-nav nav ml-auto">
                <li class="nav-item">
                    <router-link to="/user/profile" v-slot="{ href, navigate }">
                        <a class="nav-link" :href="href" @click="navigate" v-text="authenticatedUser.name"></a>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/bookings/create" v-slot="{ href, navigate }">
                        <a class="btn btn-danger" :href="href" @click="navigate">Book now</a>
                    </router-link>
                </li>
                <li is="notification-badge" class="nav-item dropdown"></li>
                <!-- <notification-badge /> -->
                <li class="nav-item dropdown">
                    <a class="nav-link" href="#" id="navbar-dropdown-menu" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-caret-down"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbar-dropdown-menu">
                        <router-link v-for="(link, key) in links" :key="key" :to="link" v-slot="{ href, route, navigate }">
                            <a class="dropdown-item" :href="href" @click="navigate" v-text="route.name"></a>
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" :href="logoutLink">Log out</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>
</template>
<script>
import { resource, pageRoute } from "@utils/network";
import NotificationBadge from "./NotificationBadge";

export default {
    name: "AuthenticatedHeader",

    components: { NotificationBadge },

    computed: {
        authenticatedUser() {
            return this.$store.getters.authenticatedUser || {};
        }
    },
    data: () => ({
        logoutLink: pageRoute('logout'),
        headerImage: resource('images/logo-red.png'),
        links: [
            "/user/bookings",
            "/user/penalties",
            "/user/addresses",
            "/user/favorite-shops",
            "/user/vouchers",
            "/user/points",
        ]
    }),
}
</script>

<style lang="css" scoped>

#navbar-brand-image {
    height: 50px;
}

.nav-item .nav-link {
    padding: 9.5px 19px;
    font-weight: 700;
}
.navbar-expand-lg .navbar-nav {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
}
.navbar-nav .dropdown-menu {
    -webkit-box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1) !important;
    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1) !important;
    position: absolute !important;
}
@media (max-width: 991px) {
    .hide-sm {
        display: none;
    }
}
</style>